export default {
  data() {
    return {
      currentPage: 0,
      filterData: {
        fromDate: "",
        toDate: "",
        fromSymbol: "",
        toSymbol: "",
        pageSize: 25,
        symbol: "",
      },
    };
  },

  computed: {
    showNext() {
      if (this.currentPage === 0) {
        if (this.histories.length < this.filterData.pageSize) {
          return false;
        } else {
          return true;
        }
      } else {
        if (
          this.histories.length < this.filterData.pageSize ||
          this.histories.length === 0
        ) {
          return false;
        } else {
          return true;
        }
      }
    },
  },

  methods: {
    setAssetToHistories(histories) {
      const assetBaseHistories = histories.map((history) => {
        return {
          ...history,
          asset: history.fromAsset || history.toAsset,
        };
      });

      return assetBaseHistories;
    },

    handleFilter(data) {
      this.filterData.fromDate = data.fromDate;
      this.filterData.toDate = data.toDate;
      this.filterData.fromSymbol = data.fromSymbol;
      this.filterData.toSymbol = data.toSymbol;
      this.filterData.pageSize = data.pageSize;
      this.filterData.symbol = data.symbol;
      this.currentPage = 0;

      this.getHistory();
    },

    handlePaginationClick(value) {
      if (value === -1) {
        if (this.currentPage > 0) {
          this.currentPage--;
          this.getHistory();
        }
      } else if (value === 1) {
        this.currentPage++;
        this.getHistory();
      }
    },
  },
};
